import dayjs from "../../../utils/dayjs";
const createDobFromAge = (age) => dayjs.utc().startOf("D").subtract(age, "years").toString();
var createDobFromAge_default = createDobFromAge;
export {
  createDobFromAge_default as default
};
